import { Component, effect, inject, model } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucidePenLine,
  lucidePackage,
  lucideTrash2,
} from '@ng-icons/lucide';

import { CrudService } from '../../core/services/crud.service';
import { RollFormComponent } from '../roll-form/roll-form.component';
import { ColorTotalComponent } from '../../shared/components/color-total/color-total.component';
import { Router } from '@angular/router';
import { DataTableColumn } from '../../shared/components/data-table/data-table.models';
import { DataTableComponent } from '../../shared/components/data-table/data-table.component';

@Component({
  selector: 'app-inventory',
  imports: [NgIcon, RollFormComponent, ColorTotalComponent, DataTableComponent],
  providers: [DecimalPipe],
  viewProviders: [provideIcons({ lucidePenLine, lucidePackage, lucideTrash2 })],

  templateUrl: './inventory.component.html',
  styles: ``,
})
export class InventoryComponent {
  private crudService = inject(CrudService);
  private router = inject(Router);
  private decimalPipe = inject(DecimalPipe);

  products!: Array<any>;
  existingRoll: any;

  columns: DataTableColumn<any>[] = [
    { key: 'product', label: 'Producto', type: 'custom', sortable: true, sortValue: row => row.name },
    { key: 'sku', label: 'SKU', sortable: true },
    { key: 'categories', label: 'Categorías', type: 'custom' },
    { key: 'rolls', label: 'Rollos', type: 'custom' },
    { key: 'total_m', label: 'Total <br/>(m)', align: 'right', sortable: true, sortValue: row => row.total_available_length_meters, renderString: row => this.decimalPipe.transform(row.total_available_length_meters, '1.2-2') || '', sortType: 'number' },
    { key: 'total_kg', label: 'Total <br/>(kg)', align: 'right', sortable: true, sortValue: row => row.total_available_weight_kg, renderString: row => this.decimalPipe.transform(row.total_available_weight_kg, '1.2-2') || '', sortType: 'number' },
    { key: 'reserved_m', label: 'Reservado <br/>(m)', align: 'right', sortable: true, sortValue: row => row.total_reserved_length_meters, renderString: row => this.decimalPipe.transform(row.total_reserved_length_meters, '1.2-2') || '', sortType: 'number' },
    { key: 'reserved_kg', label: 'Reservado <br/>(kg)', align: 'right', sortable: true, sortValue: row => row.total_reserved_weight_kg, renderString: row => this.decimalPipe.transform(row.total_reserved_weight_kg, '1.2-2') || '', sortType: 'number' }
  ];

  showModal = model(false);

  constructor() {
    effect(() => {
      if (!this.showModal()) {
        this.getProducts();
      }
    });
  }

  openModal() {
    this.existingRoll = null;
    this.showModal.set(true);
  }

  getProducts() {
    this.crudService.getProducts().subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.products = response.body;

          this.products.forEach((product) => {
            if (product.inventory_by_combination.length > 0) {
              product.colors = product.possible_colors.map((color: any) => {
                const roll_count = product.inventory_by_combination
                  .filter((item: any) => item.color === color)
                  .reduce((acc: number, curr: any) => acc + curr.roll_count, 0);

                return {
                  color: color,
                  roll_count: roll_count,
                };
              });
            }
          });
        }
      },
    });
  }

  selectProduct(product: any) {
    this.router.navigate(['/rollos'], {
      state: {
        product: {
          id: product.id,
          name: product.name,
          description: product.description,
        },
      },
    });
  }
}
